import React, { FC, useEffect, useState } from 'react';
import * as Styled from './NoMatchesNotification.styled';
import { Icon } from '@virtidev/toolbox';
import { useMounted } from '@base/utility/CustomHooks';

/** @type {FC<{onShown: () => void; active: boolean;}>} */
const NoMatchesNotification = ({ onShown, active }) => {
  const [noticeActive, setNoticeActive] = useState(false);
  const mounted = useMounted();

  // if muted notice becomes active, set a timer to hide it
  useEffect(() => {
    /** @type {NodeJS.Timeout|undefined} */
    let timer;
    if (noticeActive) {
      console.log('start timer');
      onShown();
      timer = setTimeout(() => {
        console.log('timer timed out');
        if (mounted.current) {
          setNoticeActive(false);
        }
      }, 4000);
    }
    return () => {
      if (timer) {
        console.log('clear timer');
        clearTimeout(timer);
      }
    };
  }, [noticeActive, mounted, onShown]);

  useEffect(() => {
    if (active) {
      setNoticeActive(true);
    }
  }, [active]);

  return (
    <>
      {noticeActive && (
        <Styled.NoMatchesMessage>
          <Icon size="1.5rem" icon="microphone" type="solid" />
          <div>No matches found. Please try speaking again.</div>
        </Styled.NoMatchesMessage>
      )}
    </>
  );
};

export default NoMatchesNotification;
